import type {ReactElement} from 'react';
import React from 'react';
import {BaseGlowColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-glow-color-panel';
import type {RGBA} from '@Utils/color.util';
import {colorToRgbaArray, rgbaToHexString} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromShadowOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromShadowOfActiveSlideItem';

export function SlideItemGlowColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const activeSlideItem = activeSlideUID && activeItem?.isSlideshow() ? activeItem.getSelectedSlide() : null;
  const glowColor = useGetKeyFromShadowOfActiveSlideItem('color');

  if (!activeItem?.isSlideshow()) {
    throw new Error(`Expected slideshow item but got ${activeItem?.gitype}`);
  }

  if (!activeSlideUID || !activeSlideItem) {
    throw new Error('unable to get the selected slide');
  }

  if (!glowColor) {
    throw new Error('unable to get aura properties for selected slide');
  }

  const updateGlowColor = (glowColor: RGBA, undoable = true): void => {
    void activeItem.updateSlideFromObject(
      activeSlideUID,
      {
        shadow: {
          ...activeSlideItem.toObject().shadow,
          color: rgbaToHexString(glowColor),
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseGlowColorPanel glowColor={colorToRgbaArray(glowColor)} onUpdateGlow={updateGlowColor} />;
}
